<template>
  <div class="beneficiary-legend-with-debt">
    <div class="beneficiary-legend">
      <beneficiary-type-display type="provider" variant="legend" />
      <beneficiary-type-display type="associate" variant="legend" />
      <beneficiary-type-display type="employee" variant="legend" />
      <beneficiary-type-display type="company" variant="legend" />
      <beneficiary-type-display type="debiteur" variant="legend" />
    </div>
    <div class="legend-debt-row" :title="$t('decaissement.legendDebtRowHint')">
      <span class="legend-debt-swatch" aria-hidden="true" />
      <span>{{ $t("decaissement.legendDebtRow") }}</span>
    </div>
  </div>
</template>

<script>
import BeneficiaryTypeDisplay from "./BeneficiaryTypeDisplay.vue";

export default {
  name: "BeneficiaryTypesLegend",
  components: { BeneficiaryTypeDisplay },
};
</script>
